export default {"src":"/_next/static/media/cart-2.efd0c344.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};